import { Box, Stack } from "@mui/material";
import { useApp, useNavigation, useTheme } from "contexts";
import { useGuestForm } from "./useGuestForm";
import { Fields } from "./Fields";
import { Custom } from "components";

// icons
import { ChevronLeftRounded } from "@mui/icons-material";

type Props = {
  email: string;
  redirect: string;
};

export const Form = ({ email, redirect }: Props) => {
  const { t } = useApp();
  const { theme } = useTheme();
  const { goBack } = useNavigation();
  const { current, onBlur, onChange, handleOnSubmit } = useGuestForm(
    email,
    redirect
  );

  return (
    <Box component="form" onSubmit={handleOnSubmit} mt={theme.spacing.md}>
      <Stack spacing={theme.spacing.sm}>
        <Fields current={current} onBlur={onBlur} onChange={onChange} />
      </Stack>
      <Box mt={theme.spacing.md}>
        <Stack direction="row" spacing={theme.spacing.xs}>
          <Custom.Button secondary onClick={goBack}>
            <ChevronLeftRounded />
          </Custom.Button>
          <Custom.Button
            fullWidth
            variant="contained"
            trailing="right"
            sx={{ mt: theme.spacing.md }}
            submit
          >
            {t.action.submit}
          </Custom.Button>
        </Stack>
      </Box>
    </Box>
  );
};
